<template>
  <div
    id="pageRoot"
    class="backgroundDeaf"
    style="background-color: var(--book-background-color)"
  >
    <!-- TEXTOS --------------------------------------------------------------------------------------------------------
					<p class="pageTextBigDeaf" style="margin-left: 45%; margin-top: 14%;">
						YO SOY ZORRITO
					</p>
					<p class="pageTextNormalDeaf" style="margin-left: 24%; margin-top: 24%; text-align:center;">
						ME LLAMO ZORRITO.
					</p>
					<p class="pageTextNormalDeaf" style="margin-left: 18.5%; margin-top: 28%; text-align:center;">
						TE VOY A ACOMPAÑAR<br>
						MIENTRAS LEES Y ESCRIBES.
					</p>
					<p class="pageTextBigDeaf" style="margin-left: 35%; margin-top: 77%;text-align: center;">
						CUANDO ESTOY...
					</p>
					<p class="pageTextNormalDeaf" style="margin-left: 14%; margin-top: 109%;text-align: center;">
						...CON UN LÁPIZ,
					</p>
					<p class="pageTextSmallDeaf" style="margin-left: 13.5%; margin-top: 113%;text-align: center; color: black; font-weight: bold">
						TE INVITO A ESCRIBIR.
					</p>
					<p class="pageTextNormalDeaf" style="margin-left: 40%; margin-top: 109%;text-align: center;">
						...CON UN LIBRO,
					</p>
					<p class="pageTextSmallDeaf" style="margin-left: 42%; margin-top: 113%;text-align: center; color: black; font-weight: bold">
						TE INVITO A LEER.
					</p>
					<p class="pageTextNormalDeaf" style="margin-left: 69%; margin-top: 109%;text-align: center;">
						...EN RONDA,
					</p>
					<p class="pageTextSmallDeaf" style="margin-left: 65.5%; margin-top: 113%;text-align: center; color: black; font-weight: bold">
						TE INVITO A COMPARTIR<br>
						UNA LECTURA.
					</p>
					---->
    <!-- TEXTOS -------------------------------------------------------------------------------------------------------->

    <img
      id="globe01"
      class="pageElement text-box-a hover-animation-a"
      src="/pages/img/intro/svgGlobe01.svg"
    />
    <div
      class="pageElement text-box-a hover-animation-a"
      id="globe02"
      style="background-image: url(/pages/img/intro/svgGlobe02.svg)"
    >
      <p class="textBase" id="textBox01Text">
        TE VOY A ACOMPAÑAR<br />
        MIENTRAS LEES<br />
        Y ESCRIBES
      </p>
    </div>
    <img
      id="zorrito"
      class="pageElement"
      src="/pages/img/intro/svgZorrito01.svg"
    />
  </div>
</template>
<style scoped>
#globe01 {
  position: absolute;
  left: 384px;
  top: 103px;
  z-index: 2;
}
#globe02 {
  position: absolute;
  width: 346.49px;
  height: 207.52px;
  left: 192px;
  top: 202px;
  z-index: 1;
}
#textBox01Text {
  position: absolute;
  width: 285px;
  left: 30px;
  top: 48px;
  font-size: 26px;
  line-height: 30px;
  text-align: center;
  color: #fbf8f8;
}
#zorrito {
  position: absolute;
  left: 371px;
  top: 370px;
  z-index: 3;
}
</style>
<script>
export default {
  data() {
    return {
    videos: ["p8/V8.mp4", "p8/V9.mp4", "p8/V10.mp4"]
    }
  }
}
</script>